type Props = {
  className?: string
  width?: number
  height?: number
  color?: string
  colored?: boolean
}

export const FourCirclesIcon = ({ className, width = 16, height = 17, color, colored = false }: Props) => {
  return (
    <span className={className}>
      {colored ? (
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
          <mask
            id="mask0_6176_1864"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="0"
            y="0"
            width="16"
            height="17"
          >
            <ellipse cx="7.99993" cy="8.49994" rx="7.99993" ry="7.99994" fill="#4B99E6" />
          </mask>
          <g mask="url(#mask0_6176_1864)">
            <g filter="url(#filter0_f_6176_1864)">
              <g clipPath="url(#paint0_angular_6176_1864_clip_path)" data-figma-skip-parse="true">
                <g transform="matrix(-2.48236e-10 -0.0223579 -0.0223579 2.48236e-10 13.1199 8.21785)">
                  <foreignObject x="-928.625" y="-928.625" width="1857.25" height="1857.25">
                    <div
                      style={{
                        background:
                          'conic-gradient(from 90deg,rgba(183, 236, 218, 1) 0deg,rgba(64, 173, 135, 1) 360deg)',
                        height: '100%',
                        width: '100%',
                        opacity: 1,
                      }}
                    />
                  </foreignObject>
                </g>
              </g>
              <circle cx="18.88" cy="18.88" r="18.88" transform="matrix(-1 0 0 1 31.9999 -9.42004)" />
            </g>
            <g filter="url(#filter1_f_6176_1864)">
              <g clipPath="url(#paint1_angular_6176_1864_clip_path)" data-figma-skip-parse="true">
                <g transform="matrix(-1.55673e-10 -0.0144 -0.0140211 1.59881e-10 5.43991 7.05995)">
                  <foreignObject x="-944.445" y="-944.445" width="1888.89" height="1888.89">
                    <div
                      style={{
                        background:
                          'conic-gradient(from 90deg,rgba(183, 236, 218, 1) 0deg,rgba(144, 217, 192, 1) 360deg)',
                        height: '100%',
                        width: '100%',
                        opacity: 1,
                      }}
                    />
                  </foreignObject>
                </g>
              </g>
              <ellipse cx="11.84" cy="12.16" rx="11.84" ry="12.16" transform="matrix(-1 0 0 1 17.2799 -4.30005)" />
            </g>
            <g filter="url(#filter2_f_6176_1864)">
              <circle cx="13.1199" cy="7.54003" r="18.88" fill="url(#paint2_radial_6176_1864)" fillOpacity="0.4" />
            </g>
          </g>
          <mask
            id="mask1_6176_1864"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="15"
            y="0"
            width="17"
            height="17"
          >
            <ellipse cx="23.9998" cy="8.49982" rx="7.99993" ry="7.99994" fill="#4B99E6" />
          </mask>
          <g mask="url(#mask1_6176_1864)">
            <g filter="url(#filter3_f_6176_1864)">
              <g clipPath="url(#paint3_angular_6176_1864_clip_path)" data-figma-skip-parse="true">
                <g transform="matrix(-3.19761e-10 -0.0288 -0.0288 3.19761e-10 24.9598 17.9417)">
                  <foreignObject x="-922.222" y="-922.222" width="1844.44" height="1844.44">
                    <div
                      style={{
                        background:
                          'conic-gradient(from 90deg,rgba(183, 236, 218, 1) 0deg,rgba(64, 173, 135, 1) 360deg)',
                        height: '100%',
                        width: '100%',
                        opacity: 1,
                      }}
                    />
                  </foreignObject>
                </g>
              </g>
              <circle cx="24.32" cy="24.32" r="24.32" transform="matrix(-1 0 0 1 49.2798 -4.77832)" />
            </g>
            <g filter="url(#filter4_f_6176_1864)">
              <g clipPath="url(#paint4_angular_6176_1864_clip_path)" data-figma-skip-parse="true">
                <g transform="matrix(-2.01955e-10 -0.0181895 -0.0181895 2.01955e-10 15.3598 16.6112)">
                  <foreignObject x="-935.185" y="-935.185" width="1870.37" height="1870.37">
                    <div
                      style={{
                        background:
                          'conic-gradient(from 90deg,rgba(183, 236, 218, 1) 0deg,rgba(144, 217, 192, 1) 360deg)',
                        height: '100%',
                        width: '100%',
                        opacity: 1,
                      }}
                    />
                  </foreignObject>
                </g>
              </g>
              <circle cx="15.36" cy="15.36" r="15.36" transform="matrix(-1 0 0 1 30.7198 2.26172)" />
            </g>
            <g filter="url(#filter5_f_6176_1864)">
              <circle cx="24.9988" cy="17.46" r="24.32" fill="url(#paint5_radial_6176_1864)" fillOpacity="0.4" />
            </g>
          </g>
          <mask
            id="mask2_6176_1864"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="15"
            y="16"
            width="17"
            height="17"
          >
            <ellipse cx="23.9998" cy="24.4999" rx="7.99993" ry="7.99994" fill="#4B99E6" />
          </mask>
          <g mask="url(#mask2_6176_1864)">
            <rect
              width="32"
              height="18.56"
              transform="matrix(1.19249e-08 -1 -1 -1.19249e-08 36.4797 52.66)"
              fill="#D9D9D9"
            />
            <g filter="url(#filter6_f_6176_1864)">
              <g clipPath="url(#paint6_angular_6176_1864_clip_path)" data-figma-skip-parse="true">
                <g transform="matrix(0.0203647 -0.0203647 0.0203647 0.0203647 24.6449 30.2424)">
                  <foreignObject x="-922.222" y="-922.222" width="1844.44" height="1844.44">
                    <div
                      style={{
                        background:
                          'conic-gradient(from 90deg,rgba(200, 228, 254, 1) 0deg,rgba(64, 173, 135, 1) 360deg)',
                        height: '100%',
                        width: '100%',
                        opacity: 1,
                      }}
                    />
                  </foreignObject>
                </g>
              </g>
              <circle cx="23.5135" cy="31.3738" r="24.32" transform="rotate(45 23.5135 31.3738)" />
            </g>
            <g filter="url(#filter7_f_6176_1864)">
              <circle cx="23.0398" cy="26.4201" r="9.6" fill="url(#paint7_radial_6176_1864)" fillOpacity="0.4" />
            </g>
          </g>
          <mask
            id="mask3_6176_1864"
            style={{ maskType: 'alpha' }}
            maskUnits="userSpaceOnUse"
            x="-1"
            y="16"
            width="17"
            height="17"
          >
            <ellipse cx="7.9998" cy="24.4999" rx="7.99993" ry="7.99994" fill="#4B99E6" />
          </mask>
          <g mask="url(#mask3_6176_1864)">
            <rect
              width="32"
              height="18.56"
              transform="matrix(1.19249e-08 -1 -1 -1.19249e-08 17.2798 48.5)"
              fill="#D9D9D9"
            />
            <g filter="url(#filter8_f_6176_1864)">
              <g clipPath="url(#paint8_angular_6176_1864_clip_path)" data-figma-skip-parse="true">
                <g transform="matrix(0.0203647 -0.0203647 0.0203647 0.0203647 5.44497 26.0824)">
                  <foreignObject x="-922.222" y="-922.222" width="1844.44" height="1844.44">
                    <div
                      style={{
                        background:
                          'conic-gradient(from 90deg,rgba(200, 228, 254, 1) 0deg,rgba(64, 173, 135, 1) 360deg)',
                        height: '100%',
                        width: '100%',
                        opacity: 1,
                      }}
                    />
                  </foreignObject>
                </g>
              </g>
              <circle cx="4.3136" cy="27.2137" r="24.32" transform="rotate(45 4.3136 27.2137)" />
            </g>
            <g filter="url(#filter9_f_6176_1864)">
              <circle cx="3.83975" cy="22.26" r="9.6" fill="url(#paint9_radial_6176_1864)" fillOpacity="0.4" />
            </g>
          </g>
          <defs>
            <filter
              id="filter0_f_6176_1864"
              x="-9.85613"
              y="-13.516"
              width="45.952"
              height="45.952"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur stdDeviation="2.048" result="effect1_foregroundBlur_6176_1864" />
            </filter>
            <clipPath id="paint0_angular_6176_1864_clip_path">
              <circle cx="18.88" cy="18.88" r="18.88" transform="matrix(-1 0 0 1 31.9999 -9.42004)" />
            </clipPath>
            <filter
              id="filter1_f_6176_1864"
              x="-10.4961"
              y="-8.39605"
              width="31.8721"
              height="32.5119"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur stdDeviation="2.048" result="effect1_foregroundBlur_6176_1864" />
            </filter>
            <clipPath id="paint1_angular_6176_1864_clip_path">
              <ellipse cx="11.84" cy="12.16" rx="11.84" ry="12.16" transform="matrix(-1 0 0 1 17.2799 -4.30005)" />
            </clipPath>
            <filter
              id="filter2_f_6176_1864"
              x="-9.85613"
              y="-15.436"
              width="45.952"
              height="45.952"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur stdDeviation="2.048" result="effect1_foregroundBlur_6176_1864" />
            </filter>
            <filter
              id="filter3_f_6176_1864"
              x="-3.45623"
              y="-8.87432"
              width="56.832"
              height="56.832"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur stdDeviation="2.048" result="effect1_foregroundBlur_6176_1864" />
            </filter>
            <clipPath id="paint3_angular_6176_1864_clip_path">
              <circle cx="24.32" cy="24.32" r="24.32" transform="matrix(-1 0 0 1 49.2798 -4.77832)" />
            </clipPath>
            <filter
              id="filter4_f_6176_1864"
              x="-4.09612"
              y="-1.83428"
              width="38.912"
              height="38.912"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur stdDeviation="2.048" result="effect1_foregroundBlur_6176_1864" />
            </filter>
            <clipPath id="paint4_angular_6176_1864_clip_path">
              <circle cx="15.36" cy="15.36" r="15.36" transform="matrix(-1 0 0 1 30.7198 2.26172)" />
            </clipPath>
            <filter
              id="filter5_f_6176_1864"
              x="-3.41717"
              y="-10.956"
              width="56.832"
              height="56.832"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur stdDeviation="2.048" result="effect1_foregroundBlur_6176_1864" />
            </filter>
            <filter
              id="filter6_f_6176_1864"
              x="-4.9024"
              y="2.95783"
              width="56.8319"
              height="56.8319"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur stdDeviation="2.048" result="effect1_foregroundBlur_6176_1864" />
            </filter>
            <clipPath id="paint6_angular_6176_1864_clip_path">
              <circle cx="23.5135" cy="31.3738" r="24.32" transform="rotate(45 23.5135 31.3738)" />
            </clipPath>
            <filter
              id="filter7_f_6176_1864"
              x="9.34382"
              y="12.7241"
              width="27.392"
              height="27.392"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur stdDeviation="2.048" result="effect1_foregroundBlur_6176_1864" />
            </filter>
            <filter
              id="filter8_f_6176_1864"
              x="-24.1023"
              y="-1.2022"
              width="56.8319"
              height="56.8319"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur stdDeviation="2.048" result="effect1_foregroundBlur_6176_1864" />
            </filter>
            <clipPath id="paint8_angular_6176_1864_clip_path">
              <circle cx="4.3136" cy="27.2137" r="24.32" transform="rotate(45 4.3136 27.2137)" />
            </clipPath>
            <filter
              id="filter9_f_6176_1864"
              x="-9.85625"
              y="8.56403"
              width="27.392"
              height="27.392"
              filterUnits="userSpaceOnUse"
              colorInterpolationFilters="sRGB"
            >
              <feFlood floodOpacity="0" result="BackgroundImageFix" />
              <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
              <feGaussianBlur stdDeviation="2.048" result="effect1_foregroundBlur_6176_1864" />
            </filter>
            <radialGradient
              id="paint2_radial_6176_1864"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(29.0188 26.42) rotate(-110.519) scale(45.3578)"
            >
              <stop offset="1" stopColor="#E2FFF5" />
            </radialGradient>
            <radialGradient
              id="paint5_radial_6176_1864"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(45.4788 41.78) rotate(-110.519) scale(58.427)"
            >
              <stop offset="1" stopColor="#E2FFF5" />
            </radialGradient>
            <radialGradient
              id="paint7_radial_6176_1864"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(31.124 36.0201) rotate(-110.519) scale(23.0633)"
            >
              <stop offset="1" stopColor="#E2FFF5" />
            </radialGradient>
            <radialGradient
              id="paint9_radial_6176_1864"
              cx="0"
              cy="0"
              r="1"
              gradientUnits="userSpaceOnUse"
              gradientTransform="translate(11.924 31.86) rotate(-110.519) scale(23.0633)"
            >
              <stop offset="1" stopColor="#E2FFF5" />
            </radialGradient>
          </defs>
        </svg>
      ) : (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 17" fill="none">
          <ellipse cx="3.9584" cy="4.74893" rx="3.9584" ry="3.95841" fill={color ?? '#2A2A2A'} />
          <ellipse cx="11.8749" cy="4.74893" rx="3.9584" ry="3.95841" fill={color ?? '#2A2A2A'} />
          <ellipse cx="11.8749" cy="12.665" rx="3.9584" ry="3.95841" fill={color ?? '#2A2A2A'} />
          <ellipse cx="3.9584" cy="12.665" rx="3.9584" ry="3.95841" fill={color ?? '#2A2A2A'} />
        </svg>
      )}
    </span>
  )
}
